import { Button, ButtonSize, ButtonVariant, Image, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import Trans from "@/components/Trans/Trans";
import { ROUTES } from "@/constants";

export const ExploreLorebookCTA = () => {
  return (
    <div className="flex flex-col items-center gap-lg py-lg">
      <Image src={"/Assets/exploreLorebookCTA.png"} alt="Explore Lorebook CTA" width={236} height={118} />
      <div className="flex flex-col gap-md items-center">
        <Text variant={TextVariants.HEADING_6_BOLD}>
          <Trans i18nKey="lorebook:exploreLorebook.title" />
        </Text>
        <Text variant={TextVariants.LABEL_MEDIUM_REGULAR}>
          <Trans i18nKey="lorebook:exploreLorebook.description" />
        </Text>
      </div>
      <LocalizedLink to={ROUTES.lorebooksExplore}>
        <Button variant={ButtonVariant.INVERSE} size={ButtonSize.LARGE}>
          <Trans i18nKey="lorebook:exploreLorebook.cta" />
        </Button>
      </LocalizedLink>
    </div>
  );
};
